import findAncestor from "./findAncestor";

export default () => {

  const hamburger = document.querySelector('.js-hamburger');
  const submenuToggles = document.querySelectorAll('[data-nav-toggle]');
  const mobileSubmenuToggles = document.querySelectorAll('[data-mobile-nav-toggle]');
  const hasSubNavItems = document.querySelectorAll('.has-submenu');
  const searchIcon = document.querySelector('[data-header-search-icon]');

  const isLarge = () => {
    return window.innerWidth >= 1440;
  }

  for (const hasSubNavItem of hasSubNavItems) {
    hasSubNavItem.addEventListener('mouseenter', (e) => {
      const listItem = e.target;
      const subNav = listItem.querySelector('.submenu');
      const pathways = listItem.querySelector('.submenu-pathways');
      const rect = listItem.parentNode.getBoundingClientRect();
      if (subNav) {
        if (isLarge()) {
          subNav.style.width = rect.width + 'px';
        }  else {
          subNav.style.removeProperty('width');
        }
      }
      if (pathways) {
        if (isLarge()) {
          pathways.style.width = rect.width + 'px';
        }  else {
          pathways.style.removeProperty('width');
        }
      }
    });
  }

  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle('is-active');
    document.querySelector('.js-main-menu').classList.toggle('is-active');
  });

  submenuToggles.forEach( (submenuToggle, index) => {
    submenuToggle.addEventListener("click", (e) => {
      e.preventDefault();
      const parent = findAncestor(submenuToggle, 'li');
      const subMenu = parent.querySelector('[data-sub-menu]')
      if (parent.classList.contains('active')) {
        subMenu.classList.remove('active');
        parent.classList.remove('active');
      } else {
        subMenu.classList.add('active');
        parent.classList.add('active');
      }
      return false;
    });
  });

  mobileSubmenuToggles.forEach( (submenuToggle, index) => {
    submenuToggle.addEventListener("click", (e) => {
      if (window.innerWidth < 1100) {
        e.preventDefault();
        const parent = findAncestor(submenuToggle, 'li');
        const subMenu = parent.querySelector('[data-sub-menu]')
        if (parent.classList.contains('active')) {
          subMenu.classList.remove('active');
          parent.classList.remove('active');
        } else {
          subMenu.classList.add('active');
          parent.classList.add('active');
        }
        return false;
      }
      return true;
    });
  });

  if (searchIcon) {
    searchIcon.addEventListener('click', (e) => {
      e.preventDefault();
      const parent = searchIcon.parentNode;
      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
      } else {
        parent.classList.add('active');
        parent.querySelector('input').focus();
      }
      return false;
    });
    document.addEventListener('click', (e) => {
      const searchPopup = document.querySelector('.header__search');
      const isClickInside = searchPopup.contains(e.target);
      if (!isClickInside) {
        searchIcon.parentNode.classList.remove('active');
      }
    });
  }

}
